var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('e-charts',{staticClass:"chart-Line",attrs:{"options":_vm.option,"theme":"light"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }